import { defineMessages } from 'react-intl';

export const productGroupTableMessages = defineMessages({
  nameHeader: {
    id: 'productGroupTable.nameHeader',
    defaultMessage: 'Name',
    description: 'Product table name header',
  },
  descriptionHeader: {
    id: 'productGroupTable.descriptionHeader',
    defaultMessage: 'Description',
    description: 'Product table description header',
  },
  versionsHeader: {
    id: 'productGroupTable.versionsHeader',
    defaultMessage: 'Versions',
    description: 'Product table versions header',
  },
  updatedOnHeader: {
    id: 'productGroupTable.updatedOnHeader',
    defaultMessage: 'Updated on',
    description: 'Product table updatedOn header',
  },

  actionsHeader: {
    id: 'productGroupTable.actionsHeader',
    defaultMessage: 'Actions',
    description: 'Product table actions header',
  },
  updatedOn: {
    id: 'productGroupTable.updatedOn',
    defaultMessage: '{date} at {time}',
    description: 'Product table updatedOn',
  },

  actionsEdit: {
    id: 'productGroupTable.actionsEdit',
    defaultMessage: 'Edit Product Group',
    description: 'Product table actions edit',
  },
  actionsDelete: {
    id: 'productGroupTable.actionsDelete',
    defaultMessage: 'Delete Product Group',
    description: 'Product table actions delete',
  },
});
